import { createContext, useContext } from 'react';

const PhiContext = createContext([]);

function PhiProvider({ maskedFields, children }) {
  return (
    <PhiContext.Provider value={maskedFields ?? []}>
      {children}
    </PhiContext.Provider>
  );
}

function usePhiMaskedFields() {
  return useContext(PhiContext);
}

export { PhiContext, PhiProvider, usePhiMaskedFields };
